module.exports = __webpack_public_path__ + "img/projectList_bg10.fb71724b.png";